/* eslint-disable no-unused-vars */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isNil } from 'lodash';

import { MainLayout, DashboardLayout } from 'src/layouts';

import DashboardView from 'src/views/reports/DashboardView';

import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import SettingsView from 'src/views/settings/SettingsView';

import AccountView from 'src/views/account';

import AddTransactionView from 'src/views/transactions/AddTransaction';
import AddCustomerView from 'src/views/customer/customer-add';
import TransactionDetailsView from './views/transactions/view-transaction-details';
import TransactionPDF from './views/transactions/TransactionPDF';
import TransactionSlipView from './views/transactions/TransactionSlip';
import TransactionView from './views/transactions';

import CustomerListView from 'src/views/customer/customer-list';
import CustomerProfileView from 'src/views/customer/customer-profile';

import ProductsView from 'src/views/product/product-list';
import AddProductView from 'src/views/product/product-add';
import AddProductListingView from 'src/views/product/product-listing-add';
import ProductView from './views/product/product-details';
import ProductListingView from './views/product/product-listing-view';
import ProductInformationView from './views/product/information';

import CategoriesView from './views/categories';
import CategoryView from './views/categories/CategoryView';
import CategoriesAddView from './views/categories/AddCategory';

import ManufacturersView from './views/manufacturers';
import ManufacturerView from './views/manufacturers/ManufacturerView';
// import ManufacturersAddView from './views/manufacturers/AddManufacturer';

// Suppliers
import SuppliersAddView from './views/suppliers/AddSupplier';
import SuppliersView from './views/suppliers';
import SupplierDetailsView from './views/suppliers/SupplierView';

import SalesList from './views/sales';

import RolesAndPermissionsView from './views/roles-permissions';
import RoleDetailView from './views/roles-permissions/role';
import PermissionDetailView from './views/roles-permissions/permission';

import UsersView from './views/users';
import UserDetailView from './views/users/detail';
import CreateUserView from './views/users/create';

import MaintenanceView from './maintenances';

import AuditView from './views/audit';

import InventoryView from './views/inventory';
import AvailableInventoryView from './views/available-inventory';
import CreateQuotationView from './views/quotation/create-quotation';
import { QuotationV2View } from './views/quotation-v2';
import { SMSBlast } from './views/sms-blast';

import {
  AddPcPackageView,
  PcPackageDetailsView,
  PcPackageListView
} from './views/pc-package';

import {
  GalleryListView,
  AddGalleryView,
  GalleryDetailsView
} from './views/gallery';

import { Permission, PermissionApiName, UserBasicInfo } from './types';

import { EcomOrdersListView, EcomOrderDetailsView } from './views/ecom';
import { EcommBannerView } from './views/ecomm-banner';

import {
  AddFlashDealsView,
  FlashDealsListView,
  FlashDealDetailsView
} from './views/flash-deals';
import PcwUserList from './views/pcw-user/user-list';
import UserAccountProfile from './views/pcw-user/user-profile';
import OptionListView from './views/options';
import OptionView from './views/options/OptionView';
import BranchList from './views/branch';
import { BranchView } from './views/branch/component';
import { multiBranchFeat } from './constants/feature-toggle';
import Minigame from './views/minigame';
import UserAccountAddress from './views/pcw-user/user-address';
import EventCodeGenerator from './views/event-code';
import { SMSBlastV2 } from './views/sms-blast-v2';
import KachiPointsPage from './views/kachi-points';
import KachiPointsHistory from './views/kachi-points/KachiHistory';
import { StockTransferView } from './views/stock-transfer';
import { ProductRecentOutOfStockView } from './views/product/out-of-stock/out-of-stocks-product';
import { PriceListView } from './views/price-list';
import DecayingStocksView from './views/decaying-stocks';
import { FastMovingStockView } from './views/fast-moving-products';
import { EcommSavedBuildsView } from './views/ecomm-builds';
import { TransferStockLogsView } from './views/stock-transfer/transfer-stocks-log';
import { BuildDetailsPage } from './views/ecomm-builds/details';
import { BlogView } from './views/blog';
import { CreateBlogView } from './views/blog/create';
import { BlogDetailsView } from './views/blog/details';
import BlogCategoryView from './views/blog-category';
import InventoryAuditView from './views/inventory-audits';
import WelcomePage from './views/welcome-page';
import InventoryAuditLogsView from './views/inventory-audit-logs';
import InventoryAuditLogsDetailsView from './views/inventory-audit-logs/inventory-logs-details';
import GamesListView from './views/games';
import PCBundleListView from './views/pc-bundle';
import CreatePCBundle from './views/pc-bundle/CreatePCBundle';
import PCBundleDetails from './views/pc-bundle/PCBundleDetails';
import EditBundleComponents from './views/pc-bundle/EditBundleComponents';
import CustomersQueueing from './views/customers-queueing';
import TapTapView from './views/taptap-customer';
import TaptapCustomerDetails from './views/taptap-customer/TaptapCustomerDetails';
import AddTapTapCustomer from './views/taptap-customer/AddTapTapCustomer';
import AddSalesTransferRequest from './views/taptap-customer/AddSalesTransferRequest';
import TaptapReportView from './views/taptap-customer/status-report/view/TaptapStatusReport';
import { ShippingFeeCalculatorPage } from './views/shipping-calculator';
import { PromotionalsPage } from './views/promotional';
import { PromotionalCreatePage } from './views/promotional/create';
import { PromotionalDetailPage } from './views/promotional/details';

// RMA
import RmaView from './views/rma';
import { RmaInventoryView } from './views/rma-inventory';
import CreateRMAView from './views/rma/RmaCreateView';
import RMADetailsView from './views/rma/RmaDetailsView';

// Purchase Order
import { PurchaseOrders } from './views/purchase-orders/PurchaseOrders';
import { CreatePurchaseOrder } from './views/purchase-orders/CreatePurchaseOrder';
import { PurchaseOrderDetailsView } from './views/purchase-orders/PurchaseOrderDetails';

// Cheque Management
import { CreateCheque } from './views/cheque-management/CreateCheque';
import { ChequeDetailsView } from './views/cheque-management/ChequeDetails';
import { ChequeManagement } from './views/cheque-management/ChequeManagement';

// Voucher
import VoucherDetails from './views/voucher/VoucherDetailsView';
import { VouchersListingPage } from './views/voucher';
import CreateVoucherView from './views/voucher/CreateVoucherView';
import ProductInDetails from './views/product-in/ProductInDetails';
import ProductInList from './views/product-in/ProductInList';
import TransactionInfoViewPrint from './views/transactions/view-transaction-details-print';
import SellOutView from './views/sell-out';
import PurchaseOrderReports from './views/purchase-orders/PurchaseOrderReports';
import BranchQuestionaire from './views/branch-questionaire/BranchQuestionaire';
import LiabilityChartView from './views/liability/liability-chart';
import LiabilityScheduleView from './views/liability/liability-schedule';
import AIAgentView from './views/ai-agent';
import lastRoute from './hooks/last-route/use-last-route';

// Event Subscription
import { EventSubscriptionsList } from './views/event-subscriptions';
import { CreateEventSubscriptionView } from './views/event-subscriptions/CreateEventSubscriptionView';
import { EventSubscriptionDetailsView } from './views/event-subscriptions/EventSubscriptionDetailsView';

// Tax Certificate
import { TaxCertificateList } from './views/tax-certification/index';
import { CreateTaxCertificationView } from './views/tax-certification/CreateTaxCertificationView';
import { EmailerListView } from './views/email/EmailerListView';
import { EmailerDetailsView } from './views/email/EmailerDetailsView';
import { TaxCertificateDetailsView } from './views/tax-certification/TaxCertificateDetailsView';
import { CustomerPaymentView } from './views/customer-payment';
import TapTapViewV2 from './views/tap-tap-customer-v2';
import CrmSalesView from './views/crm-sales';

// Sell Out

interface PartialRouteObject {
  caseSensitive?: boolean;
  exact?: boolean;
  children?: RouteChildren[];
  element?: React.ReactNode;
  path?: string;
}

interface RouteChildren extends PartialRouteObject {
  exact?: boolean;
}

const permissionsChecker = (
  permissionNameArg: PermissionApiName,
  permissionsArg?: Permission[]
) => {
  const index = permissionsArg?.findIndex((x) => x.name === permissionNameArg);
  return !isNil(index) && index > -1;
};

const purchaseOrderRoutes = (userInfo?: UserBasicInfo) => {
  // eslint-disable-next-line no-unused-vars
  const permissionsArg = userInfo?.all_permissions;
  let allowedPurchaseOrderRoutes: PartialRouteObject[] = [];

  if (permissionsChecker('can_read_po', permissionsArg)) {
    allowedPurchaseOrderRoutes.push({
      path: 'purchase-order',
      element: <PurchaseOrders />
    });
  }

  if (permissionsChecker('can_view_purchase_order_report', permissionsArg)) {
    allowedPurchaseOrderRoutes.push({
      path: 'purchase-order-reports',
      element: <PurchaseOrderReports />
    });
  }

  if (permissionsChecker('can_read_po', permissionsArg)) {
    allowedPurchaseOrderRoutes.push({
      path: 'purchase-order/:id',
      element: <PurchaseOrderDetailsView />
    });
  }

  if (permissionsChecker('can_create_po', permissionsArg)) {
    allowedPurchaseOrderRoutes.push({
      path: 'purchase-order/add',
      element: <CreatePurchaseOrder />
    });
  }

  if (permissionsChecker('can_view_product_in_po', permissionsArg)) {
    allowedPurchaseOrderRoutes.push({
      path: 'product-in/:id',
      element: <ProductInDetails />
    });
  }

  if (permissionsChecker('can_view_product_in_po', permissionsArg)) {
    allowedPurchaseOrderRoutes.push({
      path: 'product-in',
      element: <ProductInList />
    });
  }

  if (permissionsChecker('can_view_po_cheque', permissionsArg)) {
    allowedPurchaseOrderRoutes.push({
      path: 'cheque',
      element: <ChequeManagement />
    });
  }

  // if (permissionsChecker('can_view_rma', permissionsArg)) {
  //   const rmaViewRoutes = [
  //     { path: 'rma', element: <RmaView /> },
  //     { path: 'rma/:id', element: <RMADetailsView /> }
  //   ];

  //   allowedRmasRoutes.push(...rmaViewRoutes);
  // }

  return allowedPurchaseOrderRoutes;
};

const rmaRoute = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  let allowedRmasRoutes: PartialRouteObject[] = [];

  if (permissionsChecker('can_create_rma', permissionsArg)) {
    allowedRmasRoutes.push({
      path: 'rma/add',
      element: <CreateRMAView />
    });
  }

  if (permissionsChecker('can_view_rma', permissionsArg)) {
    const rmaViewRoutes = [
      { path: 'rma', element: <RmaView /> },
      { path: 'rma/:id', element: <RMADetailsView /> },
      { path: 'rma-inventory', element: <RmaInventoryView /> }
    ];

    allowedRmasRoutes.push(...rmaViewRoutes);
  }

  return allowedRmasRoutes;
};

const rolesPermissionRoute = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  if (permissionsChecker('edit_permissions_roles', permissionsArg)) {
    return [
      { path: 'roles-permissions', element: <RolesAndPermissionsView /> },
      { path: 'role/:id', element: <RoleDetailView /> },
      { path: 'permission/:id', element: <PermissionDetailView /> }
    ];
  }
  return [];
};

const manageUsersRoute = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  if (permissionsChecker('manage_users', permissionsArg)) {
    return [
      { path: 'users', element: <UsersView /> },
      { path: 'user/:id', element: <UserDetailView /> },
      { path: 'user/add', element: <CreateUserView /> }
    ];
  }
  return [];
};

const manageBranchesRoute = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  if (
    permissionsChecker('can_edit_branches', permissionsArg) &&
    multiBranchFeat
  ) {
    return [
      { path: 'branches', element: <BranchList /> },
      { path: 'branches/:id', element: <BranchView /> }
    ];
  }
  return [];
};

const editOptions = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  if (permissionsChecker('can_edit_options', permissionsArg)) {
    return [
      { path: 'options', element: <OptionListView /> },
      { path: 'options/:id', element: <OptionView /> }
    ];
  }
  return [];
};

const salesRoute = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  let allowedSalesRoutes: PartialRouteObject[] = [];

  if (permissionsChecker('can_view_customers', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customers/add',
      element: <AddCustomerView />
    });
  }
  if (permissionsChecker('can_view_customers', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customers/:id',
      exact: true,
      element: <CustomerProfileView />
    });
  }
  if (permissionsChecker('can_view_customers', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customers',
      element: <CustomerListView />
    });
  }
  if (
    permissionsChecker('view_sales', permissionsArg) ||
    permissionsChecker('can_view_sales_basic_dashboard', permissionsArg)
  ) {
    allowedSalesRoutes.push({
      path: 'sales',
      element: <SalesList />
    });
    // return [{ path: 'sales', element: <SalesList /> }];
  }
  // if (permissionsChecker('can_view_taptap', permissionsArg)) {
  //   allowedSalesRoutes.push({
  //     path: 'customer-taptap',
  //     element: <TapTapView />
  //   });
  // }

  if (permissionsChecker('can_view_taptap', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customer-taptap/add',
      element: <AddTapTapCustomer />
    });
  }

  if (permissionsChecker('can_view_taptap', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customer-taptap/sales-transfer-request/add',
      element: <AddSalesTransferRequest />
    });
  }

  if (permissionsChecker('can_view_taptap', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customer-taptap/:id',
      element: <TaptapCustomerDetails />
    });
  }

  if (permissionsChecker('can_view_crm_sales', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'crm-sales',
      element: <CrmSalesView />
    });
  }

  if (permissionsChecker('can_view_taptap_report', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customer-taptap/report',
      element: <TaptapReportView />
    });
  }

  if (permissionsChecker('view_ecom_user_account', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'pcw-user',
      element: <PcwUserList />
    });
  }
  if (permissionsChecker('view_ecom_user_account', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'pcw-user/user-profile/:id',
      element: <UserAccountProfile />
    });
  }
  if (permissionsChecker('view_ecom_user_account', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'pcw-user/user-address/:userId/:addressId',
      element: <UserAccountAddress />
    });
  }
  if (permissionsChecker('can_view_pricelist', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'price-list',
      element: <PriceListView />
    });
  }

  allowedSalesRoutes.push({
    path: 'shipping-fee-calculator',
    element: <ShippingFeeCalculatorPage />
  });

  if (permissionsChecker('can_view_sell_out', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'sell-out',
      element: <SellOutView />
    });
  }
  if (permissionsChecker('can_view_customer_queueing', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'customer-queueing',
      element: <CustomersQueueing />
    });
  }

  if (permissionsChecker('can_view_ecom_order', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'ecom-orders',
      element: <EcomOrdersListView />
    });
  }

  if (permissionsChecker('can_view_ecom_order', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'ecom-order/:orderRefNo',
      element: <EcomOrderDetailsView />
    });
  }

  if (permissionsChecker('can_view_quotation', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'quotation',
      element: <CreateQuotationView />
    });

    allowedSalesRoutes.push({
      path: 'quotation-v2',
      element: <QuotationV2View />
    });
  }

  if (permissionsChecker('can_view_transactions', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'transactions',
      element: <TransactionView />
    });
  }

  if (permissionsChecker('can_view_transaction_details', permissionsArg)) {
    allowedSalesRoutes.push({
      path: 'transaction/:transaction_no',
      element: <TransactionDetailsView />
    });
  }

  return allowedSalesRoutes;
};

const editManufacturerRoute = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;

  if (permissionsChecker('can_edit_manufacturer', permissionsArg)) {
    return [{ path: 'manufacturers/:id', element: <ManufacturerView /> }];
  }
  return [];
};

const accountingRoute = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  let allowedAccountingRoutes: PartialRouteObject[] = [];

  if (permissionsChecker('can_see_available_inventory', permissionsArg)) {
    allowedAccountingRoutes.push({
      path: 'available-inventory',
      element: <AvailableInventoryView />
    });
  }

  if (permissionsChecker('can_view_liability_chart', permissionsArg)) {
    allowedAccountingRoutes.push({
      path: 'liability-chart',
      element: <LiabilityChartView />
    });
  }
  if (permissionsChecker('can_view_liability_schedule', permissionsArg)) {
    allowedAccountingRoutes.push({
      path: 'liability-schedule',
      element: <LiabilityScheduleView />
    });
  }

  if (permissionsChecker('can_create_2307_form', permissionsArg)) {
    allowedAccountingRoutes.push({
      path: 'tax-certification/add',
      element: <CreateTaxCertificationView />
    });
  }

  if (permissionsChecker('can_view_tax_certificate', permissionsArg)) {
    allowedAccountingRoutes.push({
      path: 'tax-certification',
      element: <TaxCertificateList />
    });
  }

  if (permissionsChecker('can_view_tax_certificate', permissionsArg)) {
    allowedAccountingRoutes.push({
      path: 'tax-certification/:id',
      element: <TaxCertificateDetailsView />
    });
  }

  if (permissionsChecker('can_view_customer_payment', permissionsArg)) {
    allowedAccountingRoutes.push({
      path: 'customers-payment',
      element: <CustomerPaymentView />
    });
  }

  return allowedAccountingRoutes;
};

const marketingRoutes = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  let allowedMarketingRoutes: PartialRouteObject[] = [];

  if (permissionsChecker('can_view_blog', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'blog',
      element: <BlogView />
    });
  }

  if (permissionsChecker('can_view_blog', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'blog/details/:id',
      element: <BlogDetailsView />
    });
  }

  if (permissionsChecker('can_create_blog', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'blog/create',
      element: <CreateBlogView />
    });
  }

  if (permissionsChecker('can_view_blog_category', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'blog-category',
      element: <BlogCategoryView />
    });
  }

  if (permissionsChecker('view_ecomm_banners', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'ecomm-banner',
      element: <EcommBannerView />
    });
  }

  if (permissionsChecker('can_see_flash_deals', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'flash-deals',
      element: <FlashDealsListView />
    });
    allowedMarketingRoutes.push({
      path: 'flash-deals/view/:id',
      element: <FlashDealDetailsView />
    });
  }

  if (permissionsChecker('can_add_flash_deals', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'flash-deals/add',
      element: <AddFlashDealsView />
    });
  }

  if (permissionsChecker('can_create_pc_package', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'pc-package/add',
      element: <AddPcPackageView />
    });
  }

  if (permissionsChecker('can_sms_blast', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'sms-blast',
      element: permissionsChecker(
        'feature_toggle_sms_blast_v2',
        permissionsArg
      ) ? (
        <SMSBlastV2 />
      ) : (
        <SMSBlast />
      )
    });
  }
  if (permissionsChecker('view_code_event', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'code-generator',
      element: <EventCodeGenerator />
    });
  }

  if (permissionsChecker('view_minigame', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'minigame',
      element: <Minigame />
    });
  }

  //TODO: add here
  if (permissionsChecker('can_create_promotional', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'promotional',
      element: <PromotionalsPage />
    });

    allowedMarketingRoutes.push({
      path: 'promotional/create',
      element: <PromotionalCreatePage />
    });

    allowedMarketingRoutes.push({
      path: 'promotional/details/:id',
      element: <PromotionalDetailPage />
    });
  }

  //TODO: to be changed permission
  if (permissionsChecker('view_kachi_points', permissionsArg)) {
    allowedMarketingRoutes.push(
      {
        path: 'kachi-points',
        element: permissionsChecker(
          'feature_toggle_kachi_points',
          permissionsArg
        ) ? (
          <KachiPointsPage />
        ) : null
      },
      {
        path: 'kachi-points-history/:id',
        element: <KachiPointsHistory />
      }
    );
  }
  if (permissionsChecker('can_view_ecomm_saved_builds', permissionsArg)) {
    allowedMarketingRoutes.push(
      {
        path: 'saved-builds',
        element: <EcommSavedBuildsView />
      },
      {
        path: 'saved-builds/details/:id',
        element: <BuildDetailsPage />
      }
    );
  }

  if (permissionsChecker('can_read_voucher', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'vouchers',
      element: <VouchersListingPage />
    });
    allowedMarketingRoutes.push({
      path: 'vouchers/details/:id',
      element: <VoucherDetails />
    });
  }

  if (permissionsChecker('can_create_voucher', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'vouchers/create',
      element: <CreateVoucherView />
    });
  }

  if (permissionsChecker('can_view_games', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'games',
      element: <GamesListView />
    });
  }

  if (permissionsChecker('can_view_pc_package', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'pc-package',
      element: <PcPackageListView />
    });
  }

  if (permissionsChecker('can_view_pc_package_details', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'pc-package/view/:id',
      element: <PcPackageDetailsView />
    });
  }

  if (permissionsChecker('can_view_pc_gallery', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'gallery-list',
      element: <GalleryListView />
    });
  }

  if (permissionsChecker('can_view_pc_gallery_details', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'gallery/view/:id',
      element: <GalleryDetailsView />
    });
  }

  if (permissionsChecker('can_add_pc_gallery', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'gallery/add',
      element: <AddGalleryView />
    });
  }

  if (permissionsChecker('can_view_event', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'event-subscriptions',
      element: <EventSubscriptionsList />
    });
  }

  if (permissionsChecker('can_create_event', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'event-subscriptions-create',
      element: <CreateEventSubscriptionView />
    });
  }

  if (permissionsChecker('can_view_event', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'event-subscriptions/:id',
      exact: true,
      element: <EventSubscriptionDetailsView />
    });
  }

  if (permissionsChecker('can_view_pc_bundle', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'pc-bundles',
      element: <PCBundleListView />
    });
  }

  if (permissionsChecker('can_view_pc_bundle_details', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'pc-bundles/:id',
      element: <PCBundleDetails />
    });
  }

  if (permissionsChecker('can_create_pc_bundle', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'pc-bundles/add',
      element: <CreatePCBundle />
    });
  }

  if (permissionsChecker('can_view_pc_bundle_components', permissionsArg)) {
    allowedMarketingRoutes.push({
      path: 'pc-bundles/components/:id',
      element: <EditBundleComponents />
    });
  }

  // Email Marketing
  if (permissionsChecker('can_view_emailer', permissionsArg)) {
    allowedMarketingRoutes.push(
      {
        path: 'emailer',
        exact: true,
        element: <EmailerListView />
      },
      {
        path: 'emailer/:id',
        exact: true,
        element: <EmailerDetailsView />
      }
    );
  }

  return allowedMarketingRoutes;
};

const InventoryRoutes = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  let allowedInventoryRoutes: PartialRouteObject[] = [];

  if (permissionsChecker('can_inventory_audit', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'inventory-audit',
      element: <InventoryAuditView />
    });
  }

  if (permissionsChecker('can_view_audit_logs', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'inventory-audit-logs',
      element: <InventoryAuditLogsView />
    });
  }

  if (permissionsChecker('can_view_audit_logs', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'inventory-audit-logs/:id',
      element: <InventoryAuditLogsDetailsView />
    });
  }

  if (permissionsChecker('view_recent_out_of_stock', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'out-of-stocks',
      element: <ProductRecentOutOfStockView />
    });
  }

  if (permissionsChecker('can_view_decaying_stocks', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'decaying-stocks',
      element: <DecayingStocksView />
    });
  }

  if (permissionsChecker('can_view_fast_moving_products', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'fast-moving-products',
      element: <FastMovingStockView />
    });
  }

  if (permissionsChecker('view_stock_transfer', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'transfer-stock',
      element: <StockTransferView />
    });
  }

  if (permissionsChecker('can_view_transfer_stocks_logs', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'transfer-stock-logs',
      element: <TransferStockLogsView />
    });
  }

  if (permissionsChecker('can_edit_category', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'categories/:id',
      element: <CategoryView />
    });
  }

  if (permissionsChecker('can_view_inventory', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'inventory',
      element: <InventoryView />
    });
  }

  if (permissionsChecker('can_view_products', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'products',
      element: <ProductsView />
    });
  }

  if (permissionsChecker('can_view_product_details', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'products/:id',
      element: <ProductView />
    });
    allowedInventoryRoutes.push({
      path: 'products-2/:id',
      element: <ProductView />
    });
  }

  if (permissionsChecker('can_add_products', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'products/add',
      element: <AddProductView />
    });
  }

  if (permissionsChecker('can_add_product_listing', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'products-listings/add',
      element: <AddProductListingView />
    });
  }

  if (permissionsChecker('can_view_product_listing', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'products-listings/:id',
      element: <ProductListingView />
    });
  }

  if (permissionsChecker('can_edit_product_information', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'products/information/:id',
      element: <ProductInformationView />
    });
  }

  if (permissionsChecker('can_view_categories', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'categories',
      element: <CategoriesView />
    });
  }

  if (permissionsChecker('can_view_manufacturers', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'manufacturers',
      element: <ManufacturersView />
    });
  }

  if (permissionsChecker('can_view_suppliers', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'suppliers',
      element: <SuppliersView />
    });
  }

  if (permissionsChecker('can_view_supplier_details', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'suppliers/:id',
      element: <SupplierDetailsView />
    });
  }

  if (permissionsChecker('can_add_suppliers', permissionsArg)) {
    allowedInventoryRoutes.push({
      path: 'suppliers/add',
      element: <SuppliersAddView />
    });
  }

  return allowedInventoryRoutes;
};

const SettingRoutes = (userInfo?: UserBasicInfo) => {
  const permissionsArg = userInfo?.all_permissions;
  let allowedSettingRoutes: PartialRouteObject[] = [];

  if (permissionsChecker('view_sales_dashboard', permissionsArg)) {
    allowedSettingRoutes.push({
      path: 'dashboard',
      element: <DashboardView />
    });
  }

  return allowedSettingRoutes;
};

const LastViewRoute = () => {
  const { getRedirectPath } = lastRoute();

  return <Navigate to={getRedirectPath()} replace />;
};

const routes = (userInfo?: UserBasicInfo) => [
  {
    path: 'app',
    element: userInfo ? <DashboardLayout /> : <Navigate to="/login" />,
    children: [
      { path: 'branch-questionaire', element: <BranchQuestionaire /> },

      { path: 'customer-queueing', element: <CustomersQueueing /> },
      { path: 'customer-taptap/v2', element: <TapTapViewV2 /> },
      // { path: 'customer-taptap', element: <TapTapView /> },
      { path: 'customer-taptap/add', element: <AddTapTapCustomer /> },
      {
        path: 'customer-taptap/sales-transfer-request/add',
        element: <AddSalesTransferRequest />
      },
      { path: 'customer-taptap/:id', element: <TaptapCustomerDetails /> },
      { path: 'customer-taptap/report', element: <TaptapReportView /> },
      { path: 'customer-queueing', element: <CustomersQueueing /> },

      { path: 'account', element: <AccountView /> },

      { path: 'audits', element: <AuditView /> },

      { path: 'transactions', element: <TransactionView /> },
      { path: 'customers', element: <CustomerListView /> },
      { path: 'customers/add', element: <AddCustomerView /> },
      { path: 'customers/:id', exact: true, element: <CustomerProfileView /> },

      { path: 'transaction/add', exact: true, element: <AddTransactionView /> },

      {
        path: 'transaction/bulk-print',
        exact: true,
        element: <TransactionInfoViewPrint />
      },
      {
        path: 'transaction/print',
        exact: true,
        element: <TransactionPDF />
      },
      { path: 'transaction-slip', element: <TransactionSlipView /> },

      { path: 'categories/add', element: <CategoriesAddView /> },

      // manufacturers
      ...editManufacturerRoute(userInfo),
      // { path: 'manufacturers/add', element: <ManufacturersAddView /> }, // replaced by modal

      { path: 'gallery-list', element: <GalleryListView /> },
      { path: 'gallery/view/:id', element: <GalleryDetailsView /> },
      { path: 'gallery/add', element: <AddGalleryView /> },

      { path: 'suppliers', element: <SuppliersView /> },
      { path: 'suppliers/:id', element: <SupplierDetailsView /> },
      { path: 'suppliers/add', element: <SuppliersAddView /> },
      { path: 'pc-package', element: <PcPackageListView /> },
      { path: 'pc-package/view/:id', element: <PcPackageDetailsView /> },

      { path: 'products', element: <ProductsView /> },
      { path: 'products/add', element: <AddProductView /> },
      { path: 'products/:id', element: <ProductView /> },
      { path: 'products-2/:id', element: <ProductView /> },
      { path: 'products/information/:id', element: <ProductInformationView /> },

      { path: 'products-listings/add', element: <AddProductListingView /> },
      { path: 'products-listings/:id', element: <ProductListingView /> },

      { path: 'welcome-page', element: <WelcomePage /> },

      ...InventoryRoutes(userInfo),
      ...marketingRoutes(userInfo),
      ...accountingRoute(userInfo),
      ...salesRoute(userInfo),
      ...rolesPermissionRoute(userInfo),
      ...manageUsersRoute(userInfo),
      ...manageBranchesRoute(userInfo),
      ...editOptions(userInfo),
      ...rmaRoute(userInfo),
      ...purchaseOrderRoutes(userInfo),
      ...SettingRoutes(userInfo),

      // Cheque Routes
      {
        path: 'cheque/add',
        element: <CreateCheque />
      },

      //  PC Bundle Routes
      { path: 'pc-bundles', element: <PCBundleListView /> },
      { path: 'pc-bundles/add', element: <CreatePCBundle /> },
      { path: 'pc-bundles/:id', element: <PCBundleDetails /> },
      { path: 'pc-bundles/components/:id', element: <EditBundleComponents /> },
      { path: 'games', element: <GamesListView /> },

      { path: 'inventory', element: <InventoryView /> },
      // { path: 'quotation', element: <CreateQuotationView /> }

      { path: 'settings', element: <SettingsView /> },
      // TODO:  move this to purchase order routes once permssion is available
      { path: 'cheque/:id', element: <ChequeDetailsView /> },

      { path: 'ai-agent', element: <AIAgentView /> },

      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'maintenance', element: <MaintenanceView /> },
      {
        path: 'login',
        element: !userInfo ? <LoginView /> : <LastViewRoute />
      },
      { path: '404', element: <NotFoundView /> },
      { path: '/', element: <Navigate to="/app/welcome-page" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
